import { validationMixin } from 'vuelidate'
  import {
    required,
  } from 'vuelidate/lib/validators'


export default {
  name: 'clientFormComponent',
  props: ['location','index','mainForm'],
  mixins: [validationMixin],


  data: function () {
    return{
      form:{
        treatment_location_site:this.location.treatment_location_site,
        treatment_location_address:this.location.treatment_location_address,
        treatment_location_city:this.location.treatment_location_city,
        treatment_location_state:this.location.treatment_location_state,
        treatment_location_zip:this.location.treatment_location_zip,
        treatment_location_phone:this.location.treatment_location_phone,
        treatment_location_site_cross:this.location.treatment_location_site_cross,
        treatment_location_onsite_contact:this.location.treatment_location_onsite_contact,
        treatment_location_onsite_mobile:this.location.treatment_location_onsite_mobile,
        treatment_sqfeet:this.location.treatment_sqfeet,
        treatment_quote:this.location.treatment_quote,

        treatment_details_type:this.location.treatment_details_type,
        treatment_details_day:this.location.treatment_details_day,
        treatment_details_window:this.location.treatment_details_window,
        treatment_details_numbers:this.location.treatment_details_numbers,

        
      }
    }

   
  },

  validations: {

    form: {

      treatment_location_site:{required},
      treatment_location_address:{required},
      treatment_location_city:{required},
      treatment_location_state:{required},
      treatment_location_zip:{required},
      treatment_location_phone:{required},
      treatment_location_site_cross:{required},
      treatment_location_onsite_contact:{required},
      treatment_location_onsite_mobile:{required},
      treatment_sqfeet:{required},
      treatment_quote:{required},

      treatment_details_type:{required},
      treatment_details_day:{required},
      treatment_details_window:{required},
      treatment_details_numbers:{required},

    }

  },
  

  created: function () {
  },

  methods:{

    validateForm(){
      this.$v.form.$touch()
      if (!this.$v.form.$invalid) {
          return true;
      }else{
         return false;
      }
    },

    copy(){

      this.form = {
          treatment_location_site:this.mainForm.company,
          treatment_location_address:this.mainForm.address,
          treatment_location_city:this.mainForm.city,
          treatment_location_state:this.mainForm.state,
          treatment_location_zip:this.mainForm.zip,
          treatment_location_phone:this.mainForm.phone,
          treatment_location_site_cross:this.mainForm.cross_street,
          treatment_location_onsite_mobile:this.mainForm.mobile,

          treatment_details_type:this.location.treatment_details_type,
          treatment_details_day:this.location.treatment_details_day,
          treatment_details_window:this.location.treatment_details_window,
          treatment_details_numbers:this.location.treatment_details_numbers,
    
         
      }
    },

    remove_location(){
      this.$emit('remove_location',this.index)
    },

    form_change(){
      this.$emit('form_changed',this.index,this.form)
    }

  },

  watch: {

    location: {
      deep:true,
      handler(val){
        
        this.form = {
          treatment_location_site:val.treatment_location_site,
          treatment_location_address:val.treatment_location_address,
          treatment_location_city:val.treatment_location_city,
          treatment_location_state:val.treatment_location_state,
          treatment_location_zip:val.treatment_location_zip,
          treatment_location_phone:val.treatment_location_phone,
          treatment_location_site_cross:val.treatment_location_site_cross,
          treatment_location_onsite_contact:val.treatment_location_onsite_contact,
          treatment_location_onsite_mobile:val.treatment_location_onsite_mobile,
          treatment_sqfeet:val.treatment_sqfeet,

          treatment_quote:val.treatment_quote,

          treatment_details_type:val.treatment_details_type,
          treatment_details_day:val.treatment_details_day,
          treatment_details_window:val.treatment_details_window,
          treatment_details_numbers:val.treatment_details_numbers,

         }             
       
      }
   },


  }

}